/** Split a pasted territory string the same way C3 Splits does.
 *  Separators: plus, comma, whitespace. Mixed separators are fine.
 *  @param {string} inputString
 *  @returns {string[]} uppercase codes, empties removed
 */
export function parseBulkCountryString(inputString) {
    if (inputString == null) return []
    return String(inputString)
        .trim()
        .replace(/[\s,+]+/g, ',')
        .split(',')
        .map(code => code.trim().toUpperCase())
        .filter(code => code.length > 0)
}

/** Split parsed codes into ones the caller accepts and ones it does not.
 *  @param {string[]} countryCodes
 *  @param {string[]} validCodes
 *  @returns {{ valid: string[], invalid: string[] }}
 */
export function splitTerritoryCodes(countryCodes, validCodes) {
    const allowed = new Set(validCodes || [])
    const valid = []
    const invalid = []
    ;(countryCodes || []).forEach(code => {
        if (allowed.has(code)) valid.push(code)
        else invalid.push(code)
    })
    return { valid, invalid }
}
